import React, { PropsWithChildren, ReactNode, useRef, useState } from 'react';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { ActionType } from 'rc-trigger/lib/interface';

export interface DynamicPlacementPopoverProps extends PropsWithChildren {
    content: ReactNode;
    contentHeight: number;
    className?: string;
    defaultZonePlacement?: TooltipPlacement,
    isOpenFromOutside?: boolean;
    trigger?: ActionType;
    overlayClassName?: string;
    fitPositionWithScrollFromParent?: (a?: any) => any;
}

export const DynamicPlacementPopover: React.FC<DynamicPlacementPopoverProps> =
    ({ className, children, content, defaultZonePlacement, isOpenFromOutside, trigger, contentHeight, overlayClassName, fitPositionWithScrollFromParent }) => {
        const [zonePopoverPlacement, setZonePopoverPlacement] = useState<TooltipPlacement>(defaultZonePlacement || 'right');
        const [isOpen, setIsOpen] = useState(false);
        const cellRef = useRef<HTMLDivElement | null>(null);

        // TODO: expand the options and calculate it on the util file
        const onOpenChange = (visible: boolean) => {
            if (zonePopoverPlacement.includes('right') && cellRef.current) {
                const bottomOffset = window.innerHeight - cellRef.current.getBoundingClientRect().y;
                const popoverBottomOffset = contentHeight / 2;
                if (cellRef.current.getBoundingClientRect().y < popoverBottomOffset) {
                    setZonePopoverPlacement('rightTop');
                } else if (bottomOffset < popoverBottomOffset) {
                    setZonePopoverPlacement('rightBottom');
                } else {
                    setZonePopoverPlacement('right');
                }
            }
            setIsOpen(visible);
        };

        return <Popover className={className} content={content} placement={zonePopoverPlacement} onOpenChange={onOpenChange} destroyTooltipOnHide={true} trigger={trigger}
            getPopupContainer={fitPositionWithScrollFromParent} open={isOpenFromOutside ?? isOpen} showArrow={content !== null} overlayClassName={overlayClassName}>
            <div className={'dynamic-placement-popover'} ref={cellRef}>
                {children}
            </div>
        </Popover>;
    };